import { client } from '../../../../../common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters, buildUrl } from '../../../../../common-utils/functions/restUtils';
import organizationFields from '../../fields/organizationFields';

/**
 *
 * @param response
 * @param response.items
 * @param response.totalResults
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [organizationFields.UUID.key]: item[organizationFields.UUID.key],
        [organizationFields.TYPE.key]: item[organizationFields.TYPE.key],
        [organizationFields.REGISTRATION_NUMBER.key]: item[organizationFields.REGISTRATION_NUMBER.key],
        [organizationFields.LEGAL_NAME.key]: item[organizationFields.LEGAL_NAME.key],
        [organizationFields.BUSINESS_NAME.key]: item[organizationFields.BUSINESS_NAME.key],
        [organizationFields.PORTS.key]: item[organizationFields.PORTS.key],
        [organizationFields.CREATED_AT.key]: item[organizationFields.CREATED_AT.key],
        [organizationFields.UPDATED_AT.key]: item[organizationFields.UPDATED_AT.key]

    }));
    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetOrganizations = ({ query, organizationId }, enabled) => {
    return {
        queryKey: [ORGANIZATION.COLLECTION.queryKey, query, organizationId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(ORGANIZATION.COLLECTION.url, { organizationId: organizationId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetOrganizations;
